<template>
  <div>
    <div v-if="printMode && disabled" class="link" @click="dialogVisible = true">
      <i class="el-icon-location-information"></i>
      {{ midValue.address }}
    </div>
    <el-input v-else ref="main" :placeholder="$t(placeholder)" :value="midValue.address" :size="size"
      :clearable="disabled ? false : clearable" :disabled="disabled" @clear="handleInputClear" @focus="handleShow">
      <span slot="append" @click="handleShow">
        <el-button slot="append" icon="el-icon-location-information"></el-button>
      </span>
    </el-input>
    
    <l-dialog :title="$t('地址选择')" :visible.sync="dialogVisible" :height="height" :width="width" @ok="handleOK"
      @opened="handleDialogOpened">
      <div class="l-rblock" style="padding-top:40px;">
        <div class="l-BMap-top">
          <el-autocomplete v-model="addressInput" :readonly="disabled" style="width: 100%" popper-class="l-BMap-autoAddress"
            :fetch-suggestions="querySearchAsync" :trigger-on-focus="true" placeholder="请填写详细地址" clearable size="mini"
            @select="handleSelect">
            <template slot-scope="{ item }">
              <i class="el-icon-search fl mgr10" />
              <div style="overflow: hidden">
                <div class="title">{{ item.title }}</div>
                <div class="address ellipsis">{{ item.address }}</div>
              </div>
            </template>
          </el-autocomplete>
        </div>
        <l-BMap-panel ref="bmapPanel" :disabled="disabled" :address.sync="addressInput" :lng.sync="lng" :lat.sync="lat">
        </l-BMap-panel>
      </div>

    </l-dialog>
  </div>
</template>
<script>
export default {
  name: "l-BMap-select",
  props: {
    isNeedChange: false,
    value: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    size: {
      type: String,
      default: "mini",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    height: {
      type: Number,
      default: 504,
    },
    width: {
      type: Number,
      default: 960,
    },
    printMode: {
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      addressInput: '',
      lng: 0, // 精度
      lat: 0, // 维度
    };
  },
  computed: {
    midValue() {
      console.log(this.value,"this.value===========456")
      //准备地图需要的json格式
      if (this.$validatenull(this.value)) {
        return {
          address: "",
          lng: 0,
          lat: 0
        }
      }

      if (this.isNeedChange) {

        let val = this.qqMapTransBMap(parseFloat(this.value.split(",")[1]), parseFloat(this.value.split(",")[2]))
        return {
          address: this.value.split(",")[0],
          lng: val.lng,
          lat: val.lat
        };
      } else {
        return {
          address: this.value.split(",")[0],
          lng: parseFloat(this.value.split(",")[1]),
          lat: parseFloat(this.value.split(",")[2])
        };
      }


    }
  },
  methods: {
    // 将百度地图经纬度转换为腾讯、高德地图经纬度
    bMapTransQQMap(lng, lat) {
      let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);

      return {
        lng: lngs,
        lat: lats     
      }  
    },
    qqMapTransBMap(lng, lat) {
      let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      let x = lng;
      let y = lat;
      let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta) + 0.0065;
      let lats = z * Math.sin(theta) + 0.006;

      return {
        lng: lngs,
        lat: lats
      }
    },

    handleChange(val) {
      this.$emit("change", val);
    },
    handleShow() {
      if (!this.disabled) {
        this.dialogVisible = true;
      }
    },
    handleDialogOpened() {
      
      this.addressInput = this.midValue.address
      console.log(this.midValue,"this.midValue===========456")
      if(!this.midValue.address) return
      this.lng = this.midValue.lng
      this.lat = this.midValue.lat
      this.$nextTick(async () => {
        await this.$refs.bmapPanel.initMap()
      })
    },
    handleOK() {
      if(!this.addressInput) return this.$tip('请选择地址','warning')
      let lng = this.lng, lat = this.lat
      if (this.isNeedChange) {
        let val = this.bMapTransQQMap(lng, lat)
        lng = val.lng
        lat = val.lat
      }

      this.$emit("input", `${this.addressInput},${lng},${lat}`);
      this.dialogVisible = false;
      this.handleChange({
        address: this.addressInput,
        lng,
        lat
      })
    },
    querySearchAsync(str, cb) {
      this.$refs.bmapPanel.querySearchAsync(str, cb)
    },
    // 7-2、选择地址
    handleSelect(item) {
      this.addressInput = `${item.address}${item.title}`;
      this.lng = item.point.lng;
      this.lat = item.point.lat;
      this.$refs.bmapPanel.setPoint(item.point)
    },
    handleInputClear() {
      this.$emit("input", undefined)
      this.$emit("change", undefined)
    }
  }
};
</script>

<style lang="less">
@import './index.less';
</style>